<template>
  <div>
    <h2 class="title">Lista ostatnio wykorzystanych kodów</h2>
    <el-table :data="recentUsedCodes" style="width: 100%">
      <el-table-column label="Kod" width="400" prop="code"></el-table-column>
      <el-table-column label="Adres IP" prop="ip"></el-table-column>
      <el-table-column
        prop="used_on"
        :formatter="formatDate('used_on')"
        label="Data pierwszego użycia"
      />
      <el-table-column
        prop="created"
        :formatter="formatDate('created')"
        label="Data utworzenia"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    recentUsedCodes: Array
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 24px;
  margin-top: 44px;
}
.page-link {
  font-weight: 700;
}
</style>
